<form #securityPoliciesForm="ngForm" autocomplete="off" class="security-policies-dialog">
  <mat-form-field class="fullWidth">
    <mat-label>Name</mat-label>
    <input matInput required [(ngModel)]="data.name" [disabled]="isDefault" maxlength="255" name="security-policies-name">
    <mat-error>
      Name is <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field class="fullWidth">
    <mat-label>LDAP Mapping</mat-label>
    <input matInput [(ngModel)]="data.ldapMapping" maxlength="255" name="ldap-mapping">
  </mat-form-field>

  <mat-form-field class="fullWidth">
    <mat-label>Open LDAP Mapping</mat-label>
    <input matInput [(ngModel)]="data.openLdapMapping" maxlength="255" name="open-ldap-mapping">
  </mat-form-field>

  <mat-form-field class="fullWidth">
    <mat-label>Azure Mapping</mat-label>
    <input matInput [(ngModel)]="data.azureMapping" maxlength="255" name="azure-mapping">
  </mat-form-field>

  <mat-form-field class="fullWidth">
    <mat-label>Radius Mapping</mat-label>
    <input matInput [(ngModel)]="data.radiusMapping" type="number" min="0"
           max="2147483647" name="weight">
  </mat-form-field>

  <ul class="roles-list">
    <mat-radio-group [(ngModel)]="baseRoleSelection" [ngModelOptions]="{standalone: true}">
        <mat-radio-button color="primary" *ngFor="let baseRole of baseRoles" class="base-role"
                          (change)="onRuleChanged(baseRole)"
                          [disabled]="this.data.default"
                          [value]="baseRole.name">{{baseRole.display}}
        </mat-radio-button>
    </mat-radio-group>

    <li>
      <span [ngClass]="{'disabled': baseRoleSelection !== 'MONITOR' || this.data.default}">
        Allow add / edit for the following:
      </span>
    </li>
    <li *ngFor="let role of permissionRoles" [class]="role.name.toLowerCase()">
      <mat-checkbox class="permission-role" color="primary" [disabled]="baseRoleSelection !== 'MONITOR' || this.data.default"
                    [checked]="permissionRolesSelection.indexOf(role.name) > -1"
                    (change)="onRuleChanged(role)" [name]="role.name">
        {{role.display}}
      </mat-checkbox>
    </li>
  </ul>
</form>

